import Field from './refbooks/field';
import Model from './model';

import { hashify } from '../utils/arrays';





export default Model.extend( {

    endpoint: 'types', responseAt: 'newstype',
    
    defaults() {
        return {
            name: '',
            cluster: null,
            group_id: null, 
            period_of_review_in_sec: undefined,
            deadline_type: 'AT_CREATE',
            default_type: 'f',
            departments: [],
            icon: 'default_icon.png',
            role_ids: null, __all_roles_available: undefined
        };
    },

    customParser(payload) {
        if (payload.period_of_review_in_sec)
            payload.period_of_review_in_sec = +payload.period_of_review_in_sec;

        return payload;
    },

    diff(another) {
        const { 
            __all_roles_available,
            role_ids,
            ...others
        } = hashify( Model.prototype.diff.call( this, another ),
            diff => [diff.attrName, diff] );

        const diff = Object.values( others );

        if (__all_roles_available)
            if (__all_roles_available.newValue)
                return another.get( 'role_ids' ) === null
                    ? diff
                    : [...diff, { attrName: 'role_ids', newValue: null }];
            else 
                return [...diff, { attrName: 'role_ids', newValue: this.get( 'role_ids' ), oldValue: null }];
        else if (role_ids)
            return [...diff, role_ids];

        return diff;
    },

    adjusted(originalModel, { types, stickers, roles, bindings: { add, update, remove } }) {
        const json = adjustAttrsBeforeSave( this.toJSON(), { roles } );

        const fn = hash => Object.keys( hash )
            .filter( id => !remove[id] )
            .map( id => hash[id] )
            .map( ({ field, ...binding }) => {
                // todo originalModel of Field (if present)
                const { bindings, ...json } = Field.adjusted( field, null, { types, stickers, roles } );
                return {
                    ...binding,
                    field: json,
                };
            } );

        return {
            ...json,
            bindings: {
                add: fn( add ),
                update: fn( update ),
                remove: Object.keys( remove )
                    .map( id => remove[id] )
                    // only existing fields!
                    .filter( ({ field }) => !!field.id && field.id > 0 )
            }
        };
    },
    
} );






function adjustAttrsBeforeSave(json, { roles }) {
    const {
        role_ids, __all_roles_available, 
        ...other
    } = json;

    const rolesById = hashify( roles, role => [role.id, role] );

    const filteredRoleIds = role_ids == null ? role_ids : role_ids
        .filter( id => {
            const role = rolesById[id];
            // no access to role -> must preserve
            if (!role)
                return true;

            // global type is ok for any role
            return !other.cluster ||
                // global role is ok for any type
                !role.cluster || 
                // otherwise cluster must match
                role.cluster.id == json.cluster.id;
        } );

    return {
        role_ids: __all_roles_available
            ? null
            : filteredRoleIds,
        ...other
    };
}


// WEBPACK FOOTER //
// ./src/js/model/newstype.js